import { imgUrl } from "../showroom/catalogShared";
// Spa Buddy faithful document printer — auto-flows pink ISSUE / green RESULT text
// per the legacy rules: ISSUE -> Work Order, FM84, Quote ; RESULT -> Work Order, Invoice
const money = (n) => `$${Number(n || 0).toFixed(2)}`;
const esc = (s) => String(s || "").replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/\n/g, "<br/>");
const fmt = (d) => (d ? new Date(d).toLocaleDateString("en-AU") : new Date().toLocaleDateString("en-AU"));
export const FOOTER = '<div style="margin-top:34px;padding-top:10px;border-top:1px solid #e2e2e2;text-align:center;font-size:10px;color:#9aa5b1;letter-spacing:0.06em">Powered By Aqualux Nexus Pool Shop</div>';

// brand logo registry — populated once from /brand-profiles (name/company -> logo_url)
let _brandLogos = {};
export function registerBrandLogos(map) { _brandLogos = { ..._brandLogos, ...(map || {}) }; }
// white-label company registry — populated from /company-setup (name -> full CompanySetup record)
let _companyInfo = {};
export function registerCompanyInfo(map) { _companyInfo = { ..._companyInfo, ...(map || {}) }; }
export function resolveBrand(brand) {
  if (brand && typeof brand === "object") return brand;
  return _companyInfo[String(brand || "").trim().toLowerCase()] || { name: brand || "Aqualux Nexus" };
}
export function brandHead(brand) {
  const c = resolveBrand(brand);
  const url = c.logo_url || _brandLogos[String(c.name || brand || "").trim().toLowerCase()];
  const logo = url
    ? `<img src="${url}" alt="${esc(c.name)}" style="max-height:56px;max-width:260px;object-fit:contain"/>`
    : `<div class="brand">${esc(c.name || "Aqualux Nexus")}</div>`;
  const addr = [c.address, [c.suburb, c.state, c.postcode].filter(Boolean).join(" ")].filter(Boolean).join(", ");
  const line2 = [c.phone ? "Ph " + c.phone : "", c.email || "", c.website || ""].filter(Boolean).join("  ·  ");
  const abn = [c.abn ? "ABN " + c.abn : "", c.acn ? "ACN " + c.acn : ""].filter(Boolean).join("  ·  ");
  const bits = [addr, line2, abn].filter(Boolean).map(esc).join("<br/>");
  return `${logo}${bits ? `<div style="margin-top:5px;font-size:11px;color:#555;line-height:1.5">${bits}</div>` : ""}`;
}
function bankBlock(brand) {
  const c = resolveBrand(brand);
  if (!c.bsb && !c.account) return "";
  return `Direct Deposit — ${esc(c.account_name || c.name || "")} · ${esc(c.bank || "")} ${esc(c.branch || "")} · BSB ${esc(c.bsb || "")} · Acct ${esc(c.account || "")}`;
}

function clientBlock(client, addressed) {
  const a = client.address || {};
  const addr = [a.street, [a.suburb, a.state, a.postcode].filter(Boolean).join(" ")].filter(Boolean).join("<br/>");
  const names = (addressed && addressed.name ? String(addressed.name).split(";") : []).map((s) => s.trim()).filter(Boolean);
  const emails = (addressed && addressed.email ? String(addressed.email).split(";") : []).map((s) => s.trim()).filter(Boolean);
  const attn = names.length
    ? names.map((n, i) => `<b>${esc(n)}</b>${i === 0 && addressed.relationship ? ` (${esc(addressed.relationship)})` : ""}${emails[i] ? "<br/>" + esc(emails[i]) : ""}`).join("<br/>") + `<br/><span style="color:#666">c/o ${esc(client.name)}</span><br/>`
    : `<b>${esc(client.name)}</b><br/>`;
  return `<div>${attn}${esc(client.company || "")}${client.company ? "<br/>" : ""}${addr}<br/>${esc(client.phone || "")}${client.email ? " · " + esc(client.email) : ""}</div>`;
}

const COL_LABEL = { Shell: "Spa Shell", Cabinet: "Cabinet", Cover: "Hard Cover" };
function colourPanel(cols) {
  if (!cols || !cols.length) return "";
  const order = ["Shell", "Cabinet", "Cover"];
  const sorted = [...cols].sort((a, b) => order.indexOf(a.item) - order.indexOf(b.item));
  return `<div style="margin:8px 0 4px;padding:8px 10px;border:1.5px solid #c9d9ec;border-radius:8px;background:#f7fafe">
    <div style="font-size:11px;font-weight:800;letter-spacing:.08em;color:#123a63;margin-bottom:6px">YOUR COLOUR SELECTION</div>
    <div style="display:flex;gap:16px">${sorted.map((c) => `<div style="text-align:center;width:110px">
      ${c.image ? `<img src="${imgUrl(c.image)}" style="width:100px;height:100px;object-fit:cover;border-radius:6px;border:1px solid #9db8d6"/>` : `<div style="width:100px;height:100px;border-radius:6px;border:1px dashed #9db8d6;display:flex;align-items:center;justify-content:center;font-size:10px;color:#999">No swatch</div>`}
      <div style="font-size:10px;color:#666;margin-top:3px">${esc(COL_LABEL[c.item] || c.item)}</div>
      <div style="font-size:12px;font-weight:800;color:#123a63">${esc(c.name)}</div></div>`).join("")}</div></div>`;
}

function rowsTable(rows) {
  const body = (rows || []).map((r) => `<tr>
    <td>${esc(r.name)}${r.colour_name ? `<div style="font-size:11px;color:#666;margin-top:2px">Colour: <b>${esc(r.colour_name)}</b>${r.colour_image ? ` <img src="${imgUrl(r.colour_image)}" style="height:20px;width:20px;object-fit:cover;vertical-align:middle;border-radius:3px;border:1px solid #ccc;margin-left:4px"/>` : ""}</div>` : ""}${colourPanel(r.colours)}</td>
    <td class="c">${r.qty}</td>
    <td class="r">${money(r.unit)}</td>
    <td class="r">${money(r.disc || 0)}</td>
    <td class="r">${money(r.net)}</td></tr>`).join("");
  return `<table class="lines"><thead><tr><th>Item</th><th class="c">Qty</th><th class="r">Unit</th><th class="r">Disc</th><th class="r">Nett</th></tr></thead><tbody>${body}</tbody></table>`;
}

/**
 * @param kind 'work_order' | 'quote' | 'invoice'
 */
export function printDoc({ kind, brand, client, addressed, docNo, dateStr, issue, result, rows, total, note, extraMeta }) {
  const titles = { work_order: "WORK ORDER", quote: "QUOTATION", invoice: "TAX INVOICE" };
  const title = titles[kind] || "DOCUMENT";
  const w = window.open("", "_blank");
  if (!w) { alert("Popup blocked — please allow popups to print."); return; }
  const issueBlock = issue
    ? `<div class="box pink"><div class="boxh">ISSUE — reported by client</div><div class="boxb">${esc(issue)}</div></div>` : "";
  const resultBlock = result
    ? `<div class="box green"><div class="boxh">RESULT — work carried out</div><div class="boxb">${esc(result)}</div></div>` : "";
  w.document.write(`<html><head><title>${title} ${docNo || ""}</title><style>
    *{box-sizing:border-box} body{font-family:Arial,Helvetica,sans-serif;color:#1a2b3c;padding:36px;max-width:820px;margin:0 auto}
    .top{display:flex;justify-content:space-between;align-items:flex-start;border-bottom:3px solid #123a63;padding-bottom:12px}
    .brand{font-size:22px;font-weight:800;color:#123a63}
    .title{font-size:26px;font-weight:800;color:#123a63;text-align:right}
    .meta{margin-top:6px;font-size:12px;color:#555;text-align:right}
    .parties{display:flex;justify-content:space-between;gap:24px;margin:18px 0;font-size:13px}
    .box{border:1px solid #bbb;border-radius:4px;margin:10px 0;overflow:hidden}
    .boxh{padding:5px 10px;font-size:11px;font-weight:800}
    .boxb{padding:10px;font-size:13px;background:#fff}
    .pink .boxh{background:#f8c9cf} .green .boxh{background:#c9f0c0}
    table.lines{width:100%;border-collapse:collapse;margin-top:14px;font-size:13px}
    table.lines th,table.lines td{border-bottom:1px solid #e2e2e2;padding:7px 8px;text-align:left}
    table.lines th{background:#eef3f9;color:#123a63} .c{text-align:center!important} .r{text-align:right!important}
    .total{margin-top:14px;text-align:right;font-size:16px;font-weight:800;color:#123a63}
    .note{margin-top:16px;font-size:12px;color:#555;white-space:pre-wrap}
    @media print{body{padding:12px}}
  </style></head><body>
    <div class="top">
      <div>${brandHead(brand)}</div>
      <div><div class="title">${title}</div><div class="meta">No. <b>${docNo || ""}</b><br/>Date: ${fmt(dateStr)}${extraMeta ? "<br/>" + esc(extraMeta) : ""}</div></div>
    </div>
    <div class="parties"><div><b>To:</b><br/>${clientBlock(client, addressed)}</div></div>
    ${issueBlock}${resultBlock}
    ${rowsTable(rows)}
    <div class="total">Total: ${money(total)}</div>
    ${note ? `<div class="note"><b>Notes:</b> ${esc(note)}</div>` : ""}
    ${FOOTER}
  </body></html>`);
  w.document.close();
  w.focus();
  w.print();
}

// ---- Legacy (Spa Buddy) invoice / quote — header-only doc on letterhead ----
export function printLegacyDoc(doc, client, brand, kind) {
  const title = kind === "quote" ? "QUOTATION" : "TAX INVOICE";
  const docNo = kind === "quote" ? doc.quote_number : doc.sale_number;
  const w = window.open("", "_blank");
  if (!w) { alert("Popup blocked — please allow popups to print."); return; }
  const line = (label, val) => (val || val === 0 ? `<tr><td class="l">${esc(label)}</td><td class="r"><b>${esc(String(val))}</b></td></tr>` : "");
  const rows = kind === "quote"
    ? line("Gross", money(doc.gross)) + line("Discount", money(doc.discount)) + line("Amount", money(doc.amount || doc.total))
    : line("Gross", money(doc.gross)) + line("Discount", money(doc.discount)) + line("Nett", money(doc.nett || doc.total)) + line("Balance Owing", money(doc.balance_due));
  const attnName = kind === "quote" ? doc.quote_to : doc.invoice_to;
  w.document.write(`<html><head><title>${title} ${docNo || ""}</title><style>
    *{box-sizing:border-box} body{font-family:Arial,Helvetica,sans-serif;color:#1a2b3c;padding:36px;max-width:820px;margin:0 auto}
    .top{display:flex;justify-content:space-between;align-items:flex-start;border-bottom:3px solid #123a63;padding-bottom:12px}
    .brand{font-size:22px;font-weight:800;color:#123a63}
    .title{font-size:26px;font-weight:800;color:#123a63;text-align:right}
    .meta{margin-top:6px;font-size:12px;color:#555;text-align:right}
    .parties{display:flex;justify-content:space-between;gap:24px;margin:18px 0;font-size:13px}
    table.sum{width:320px;border-collapse:collapse;margin-top:14px;margin-left:auto;font-size:14px}
    table.sum td{padding:6px 8px;border-bottom:1px solid #e2e2e2} table.sum .l{color:#555} table.sum .r{text-align:right}
    .legacy{display:inline-block;margin-top:10px;font-size:11px;font-weight:800;color:#9a6b00;background:#fff2cc;border:1px solid #e0c060;border-radius:4px;padding:3px 8px}
    .fields{margin-top:6px;font-size:13px;color:#333}.fields div{margin:2px 0}
    @media print{body{padding:12px}}
  </style></head><body>
    <div class="top">
      <div>${brandHead(brand)}</div>
      <div><div class="title">${title}</div><div class="meta">No. <b>${esc(docNo || "")}</b><br/>Date: ${fmt(doc.created_at)}</div></div>
    </div>
    <div class="parties"><div><b>To:</b><br/>${clientBlock(client, attnName ? { name: attnName } : null)}</div>
      <div class="fields">
        ${doc.salesperson ? `<div><b>Salesperson:</b> ${esc(doc.salesperson)}</div>` : ""}
        ${doc.status ? `<div><b>Status:</b> ${esc(doc.status)}</div>` : ""}
        ${doc.delivery_date ? `<div><b>Delivery:</b> ${fmt(doc.delivery_date)}</div>` : ""}
      </div>
    </div>
    <table class="sum"><tbody>${rows}</tbody></table>
    <div class="legacy">Historical record imported from Spa Buddy — line-item detail was not stored in the original database.</div>
    ${FOOTER}
  </body></html>`);
  w.document.close();
  w.focus();
  w.print();
}

// ---- WORK ORDER "JOB CARD" — faithful replica of the Access WorkOrder report ----
function contactRows(client) {
  const cns = client.contact_numbers || [];
  if (cns.length) {
    return cns.map((c) => {
      const nm = [c.first_name, c.surname].filter(Boolean).join(" ") || client.name;
      const rel = c.relationship ? ` (${c.relationship})` : "";
      return `<tr><td>${esc(nm)}${rel}</td><td>${esc(c.phone_type || "")}</td><td><b>${esc(c.number || "")}</b></td></tr>`;
    }).join("");
  }
  const a = client.address || {};
  const fallback = [["Phone", client.phone], ["Mobile", client.mobile], ["Email", client.email]]
    .filter(([, v]) => v).map(([t, v]) => `<tr><td>${esc(client.name)}</td><td>${t}</td><td><b>${esc(v)}</b></td></tr>`).join("");
  return fallback || `<tr><td>${esc(client.name)}</td><td></td><td></td></tr>`;
}

export function printJobCard(wo, client, brand, rows, total) {
  const w = window.open("", "_blank");
  if (!w) { alert("Popup blocked — please allow popups to print."); return; }
  const a = client.address || {};
  const addr = [a.street, [a.suburb, a.state, a.postcode].filter(Boolean).join(" ")].filter(Boolean).join(", ");
  const items = (rows || []).map((r) => `<tr>
      <td>${esc(r.name)}</td><td class="c">${r.qty}</td><td class="r">${money(r.unit)}</td>
      <td class="r">${money(r.disc || 0)}</td><td class="r">${money(r.net)}</td></tr>`).join("");
  const meta = [
    ["Date Booked", wo.date_booked ? fmt(wo.date_booked) : ""],
    ["Booked By", wo.booked_by || wo.taken_by || ""],
    ["Technician", wo.technician || ""],
    ["Work Type", wo.work_type || ""],
    ["Date Completed", wo.date_completed ? fmt(wo.date_completed) : ""],
    ["Make / Model", [wo.make, wo.model].filter(Boolean).join(" ")],
    ["Serial", wo.serial || ""],
  ].filter(([, v]) => v).map(([k, v]) => `<tr><td class="mk">${k}</td><td class="mv">${esc(v)}</td></tr>`).join("");

  w.document.write(`<html><head><title>JOB CARD ${wo.wo_number || ""}</title><style>
    *{box-sizing:border-box} body{font-family:Arial,Helvetica,sans-serif;color:#1a2b3c;padding:30px;max-width:840px;margin:0 auto;font-size:13px}
    .top{display:flex;justify-content:space-between;align-items:flex-start;border-bottom:3px solid #123a63;padding-bottom:10px}
    .brand{font-size:22px;font-weight:800;color:#123a63}
    .jc{font-size:30px;font-weight:900;color:#123a63;text-align:right;letter-spacing:0.06em}
    .won{font-size:14px;color:#333;text-align:right;margin-top:2px}
    .grid{display:flex;gap:22px;margin:16px 0}
    .col{flex:1}
    .lbl{font-size:11px;font-weight:800;color:#123a63;text-transform:uppercase;letter-spacing:0.05em;margin-bottom:3px}
    table.cn{width:100%;border-collapse:collapse;font-size:12px} table.cn td{border-bottom:1px solid #eee;padding:3px 6px}
    table.meta{border-collapse:collapse;font-size:12px} table.meta td{padding:2px 8px} .mk{color:#666} .mv{font-weight:700}
    .band{background:#123a63;color:#fff;font-weight:800;font-size:12px;letter-spacing:0.04em;padding:6px 10px;margin-top:8px}
    .issue{border:1px solid #d8b4b4;background:#fdf3f3;border-radius:0 0 4px 4px;padding:10px;min-height:70px;white-space:pre-wrap;font-size:13px}
    table.lines{width:100%;border-collapse:collapse;margin-top:12px}
    table.lines th,table.lines td{border-bottom:1px solid #e6e6e6;padding:6px 8px;text-align:left}
    table.lines th{background:#eef3f9;color:#123a63;font-size:11px} .c{text-align:center!important}.r{text-align:right!important}
    .tot{margin-top:10px;text-align:right;font-size:15px;font-weight:800;color:#123a63}
    .sign{margin-top:30px;font-size:12px;color:#333}
    @media print{body{padding:14px}}
  </style></head><body>
    <div class="top">
      <div>${brandHead(brand)}</div>
      <div><div class="jc">JOB CARD</div><div class="won">Work Order No. <b>${esc(wo.wo_number || "")}</b></div></div>
    </div>
    <div class="grid">
      <div class="col"><div class="lbl">Client</div><b>${esc(client.name)}</b><br/>${esc(client.company || "")}${client.company ? "<br/>" : ""}${esc(addr)}
        <table class="cn" style="margin-top:6px">${contactRows(client)}</table></div>
      <div class="col" style="text-align:right"><table class="meta" style="margin-left:auto">${meta}</table></div>
    </div>
    <div class="band">ITEMS QUOTED AND/OR PAID FOR — OR PARTS REQUIRED (MODEL ETC)</div>
    <div class="issue">${esc(wo.issue_text || "")}</div>
    ${wo.result_text ? `<div class="band" style="background:#2e5a1e">WORK CARRIED OUT</div><div class="issue" style="border-color:#bcd8b0;background:#f3faef">${esc(wo.result_text)}</div>` : ""}
    <table class="lines"><thead><tr><th>Item / Part</th><th class="c">Qty</th><th class="r">Unit</th><th class="r">Disc</th><th class="r">Nett</th></tr></thead>
      <tbody>${items || '<tr><td colspan="5" style="color:#888;padding:10px">No parts/labour lines.</td></tr>'}</tbody></table>
    <div class="tot">Total: ${money(total)}</div>
    <div class="sign">Client Signature: &nbsp;. .......................................................  &nbsp; Date: ____________</div>
    ${FOOTER}
  </body></html>`);
  w.document.close(); w.focus(); w.print();
}

// Work Order tab helpers — a WO generates its own WO / Quote / Invoice documents
export function printWorkOrderDoc(kind, wo, client, brand, rows, total) {
  if (kind === "work_order") { printJobCard(wo, client, brand, rows, total); return; }
  printDoc({
    kind, brand, client, docNo: wo.wo_number, dateStr: wo.date_booked || wo.created_at,
    issue: kind === "invoice" ? "" : wo.issue_text,   // ISSUE -> WO + Quote (not Invoice)
    result: kind === "quote" ? "" : wo.result_text,   // RESULT -> WO + Invoice (not Quote)
    rows, total,
    extraMeta: wo.invoiced_by ? `Work Type: ${wo.work_type || ""}` : "",
  });
}

// ---- FM84 — Spa Industries "Agent/Dealer Warranty or Service Work Authority Request Form" ----
export function printFM84(d, client, wo, brand) {
  const w = window.open("", "_blank");
  if (!w) { alert("Popup blocked — please allow popups to print the FM84."); return; }
  const c = resolveBrand(brand);
  const a = client.address || {};
  const custName = d.client_name || client.name || "";
  const line = (v) => esc(v || "");
  const box = (label, val) => `<div class="fld"><span class="fl">${label}</span><span class="fv">${line(val)}</span></div>`;
  w.document.write(`<html><head><title>FM84 ${esc(d.fm84_number || "")}</title><style>
    *{box-sizing:border-box} body{font-family:Arial,Helvetica,sans-serif;color:#111;padding:26px;max-width:820px;margin:0 auto;font-size:12px}
    .hd{display:flex;justify-content:space-between;align-items:flex-start;border-bottom:2px solid #111;padding-bottom:8px}
    .hd .logo img{max-height:52px;max-width:230px;object-fit:contain}
    .rev{font-size:10px;color:#444;text-align:right;line-height:1.5}
    h1{font-size:16px;margin:10px 0 2px;text-align:center;font-weight:800}
    .sub{text-align:center;font-size:12px;font-weight:700;margin-bottom:4px}
    .email{text-align:center;font-size:11px;color:#123a63;margin-bottom:10px}
    .sec{border:1px solid #333;margin-top:8px}
    .sech{background:#e6e6e6;font-weight:800;font-size:11px;padding:4px 8px;border-bottom:1px solid #333;letter-spacing:0.03em}
    .grid2{display:grid;grid-template-columns:1fr 1fr;gap:0}
    .fld{display:flex;border-bottom:1px solid #ddd;padding:4px 8px;min-height:24px}
    .grid2 .fld:nth-child(odd){border-right:1px solid #ddd}
    .fl{color:#555;min-width:120px;font-weight:600}
    .fv{flex:1;border-bottom:1px dotted #bbb;padding-left:6px}
    .area{padding:8px;min-height:64px;white-space:pre-wrap}
    table.parts{width:100%;border-collapse:collapse} table.parts th,table.parts td{border:1px solid #ccc;padding:4px 6px;font-size:11px;text-align:left} table.parts th{background:#f0f0f0}
    .warn{font-size:10px;color:#b1281f;margin-top:8px;line-height:1.5}
    .note{font-size:10px;color:#444;margin-top:4px}
    @media print{body{padding:12px}}
  </style></head><body>
    <div class="hd">
      <div class="logo">${c.logo_url ? `<img src="${c.logo_url}"/>` : `<b>${esc(c.name || "")}</b>`}</div>
      <div class="rev">Page 1 of 1<br/>Revision: D<br/>Rev.Date: 01/04/15</div>
    </div>
    <h1>FM84 Agent/Dealer Warranty or Service Work Authority Request Form</h1>
    <div class="email">Email completed form to the Service Department <b>service@spaindustries.com.au</b></div>

    <div class="sec"><div class="sech">AGENTS DETAILS</div>
      <div class="grid2">
        ${box("Store Name:", c.name)}${box("State:", c.state)}
        ${box("Street Address:", c.address)}${box("Suburb:", c.suburb)}
      </div></div>

    <div class="sec"><div class="sech">SPA DETAILS</div>
      <div class="grid2">
        ${box("Contact Name:", d.technician)}${box("Date of Request:", d.created_at ? fmt(d.created_at) : "")}
        ${box("Contact Phone:", c.phone)}${box("Spa Model:", [d.spa_make, d.spa_model].filter(Boolean).join(" "))}
        ${box("Spa Serial No:", d.serial)}${box("Date of Purchase:", d.purchase_date ? fmt(d.purchase_date) : "")}
        ${box("Warranty:", d.warranty_authority)}${box("POP Attached:", d.pop_attached)}
        ${box("HCCP Valid:", d.hccp_valid)}${box("HCCP No:", d.hccp_no)}
      </div></div>

    <div class="sec"><div class="sech">CUSTOMER DETAILS</div>
      <div class="grid2">
        ${box("Name:", custName)}${box("State:", a.state)}
        ${box("Street Address:", a.street)}${box("Suburb:", a.suburb)}
        ${box("Contact Phone:", client.phone)}${box("Mobile Number:", client.mobile)}
        ${box("Email address:", client.email)}${box("Contact Name:", custName)}
      </div></div>

    <div class="sec"><div class="sech">REPORTED FAULT</div><div class="area">${esc(d.fault_description || "")}</div></div>
    <div class="sec"><div class="sech">DETAILS OF ATTEMPT TO RESOLVE — WHO / WHAT / WHEN / HOW?</div><div class="area">${esc(d.resolution || "")}</div></div>
    <div class="sec"><div class="sech">DESCRIPTION &amp; CODE OF PARTS REQUIRED</div>
      <table class="parts"><thead><tr><th>Part Description &amp; Code</th><th style="width:70px">Qty</th></tr></thead>
        <tbody>${(d.parts && d.parts.length ? d.parts : [{}, {}, {}, {}]).map((p) => `<tr><td>${esc(p.desc || "")}</td><td>${esc(p.qty || "")}</td></tr>`).join("")}</tbody></table>
    </div>
    <div class="warn">FAULTY PARTS MUST BE RETURNED TO SPA INDUSTRIES WITHIN 30 DAYS OF INVOICE DATE, OR THE PART/S WILL BE CHARGED FOR.</div>
    <div class="note">For all Warranty service requests, a copy of the Proof of Purchase must be included.</div>
    ${FOOTER}
  </body></html>`);
  w.document.close(); w.focus(); w.print();
}

// ---- Service Contract (Access "Regular Contracts" report) ----
export function printContracts(client, contracts, brand) {
  const w = window.open("", "_blank");
  if (!w) { alert("Popup blocked — please allow popups to print."); return; }
  const a = client.address || {};
  const addr = [a.street, [a.suburb, a.state, a.postcode].filter(Boolean).join(" ")].filter(Boolean).join(", ");
  const list = (contracts || []).filter((c) => c.active !== false);
  const rows = list.map((c) => `<tr><td>${esc(c.frequency)}</td><td>${esc(c.description)}</td><td class="r">${money(c.fee)}</td></tr>`).join("");
  const total = list.reduce((s, c) => s + (Number(c.fee) || 0), 0);
  w.document.write(`<html><head><title>Service Contract — ${esc(client.name)}</title><style>
    *{box-sizing:border-box} body{font-family:Arial,Helvetica,sans-serif;color:#1a2b3c;padding:32px;max-width:820px;margin:0 auto;font-size:13px}
    .top{display:flex;justify-content:space-between;align-items:flex-start;border-bottom:3px solid #123a63;padding-bottom:12px}
    .title{font-size:26px;font-weight:800;color:#123a63;text-align:right;letter-spacing:0.04em}
    .parties{margin:16px 0}
    .lbl{font-size:11px;font-weight:800;color:#123a63;text-transform:uppercase;letter-spacing:0.05em}
    table.lines{width:100%;border-collapse:collapse;margin-top:12px} table.lines th,table.lines td{border-bottom:1px solid #e2e2e2;padding:8px;text-align:left}
    table.lines th{background:#123a63;color:#fff;font-size:11px} .r{text-align:right!important}
    .tot{margin-top:12px;text-align:right;font-size:16px;font-weight:800;color:#123a63}
    .terms{margin-top:18px;font-size:11px;color:#555;line-height:1.6}
    .sign{margin-top:34px;font-size:12px}
  </style></head><body>
    <div class="top"><div>${brandHead(brand)}</div><div class="title">SERVICE CONTRACT</div></div>
    <div class="parties"><div class="lbl">Client</div><b>${esc(client.name)}</b><br/>${esc(client.company || "")}${client.company ? "<br/>" : ""}${esc(addr)}<br/>${esc(client.phone || "")}${client.email ? " · " + esc(client.email) : ""}</div>
    <table class="lines"><thead><tr><th>Frequency</th><th>Contract / service description</th><th class="r">Fee</th></tr></thead>
      <tbody>${rows || '<tr><td colspan="3" style="color:#888;padding:10px">No active service contracts.</td></tr>'}</tbody></table>
    <div class="tot">Total per service: ${money(total)}</div>
    <div class="terms">This agreement confirms the recurring pool/spa service contract detailed above between ${esc((resolveBrand(brand).name) || "us")} and the client. Services are performed at the stated frequency and fee. Either party may vary or cancel this contract with reasonable written notice. Fees are subject to review and include GST where applicable.</div>
    <div class="sign">Client Signature: &nbsp;. .......................................................  &nbsp; Date: ____________<br/><br/>
      For ${esc((resolveBrand(brand).name) || "")}: &nbsp;. .......................................................</div>
    ${FOOTER}
  </body></html>`);
  w.document.close(); w.focus(); w.print();
}

// ---- Statement of account (all invoices + balances) ----
// ---- TAX INVOICE — faithful replica of the Spa Buddy (Access) "Invoice" report ----
export function printInvoiceReport(sale, client, brand, addressed) {
  const w = window.open("", "_blank");
  if (!w) { alert("Popup blocked — please allow popups to print."); return; }
  const items = sale.items || [];
  const gross = items.reduce((a, i) => a + (i.qty || 0) * (i.unit_price || 0), 0) || Number(sale.subtotal || 0);
  const disc = items.reduce((a, i) => a + (i.discount || 0), 0) || Number(sale.discount || 0);
  const saleAmt = Number(sale.total || (gross - disc));
  const payments = sale.payments || [];
  const paid = payments.reduce((a, p) => a + (p.amount || 0), 0);
  const balance = Math.max(saleAmt - paid, 0);
  const a = client.address || {};
  const addr = [a.street, [a.suburb, a.state, a.postcode].filter(Boolean).join(" ")].filter(Boolean).join("<br/>");
  const isTP = !!(addressed && addressed.name);  // billed to a third party (insurer / NDIS / agent), not the client
  const invoiceTo = isTP ? String(addressed.name).split(";").map((s) => s.trim()).filter(Boolean).join(", ") : (client.display_name || client.name);
  const billerCompany = isTP && addressed.company ? esc(addressed.company) : "";
  const billerAddr = isTP && addressed.address ? esc(addressed.address).replace(/\n/g, "<br/>") : "";
  const regLines = [
    client.regarding ? `Regarding: ${esc(client.regarding)}` : "",
    client.service_code ? `Service Code: ${esc(client.service_code)}` : "",
    client.participant_number ? `Participant Number: ${esc(client.participant_number)}` : "",
  ].filter(Boolean).join("<br/>");

  const lineRows = items.map((i) => `<tr>
      <td>${esc(i.name)}${i.colour_name ? `<div class="col">Colour: <b>${esc(i.colour_name)}</b>${i.colour_image ? ` <img src="${i.colour_image}"/>` : ""}</div>` : ""}</td>
      <td class="c">${i.qty}</td>
      <td class="r">${money((i.qty || 0) * (i.unit_price || 0))}</td>
      <td class="r">${money(i.discount || 0)}</td>
      <td class="r">${money(i.line_total != null ? i.line_total : (i.qty || 0) * (i.unit_price || 0) - (i.discount || 0))}</td>
    </tr>`).join("");
  const payRows = payments.length
    ? payments.map((p) => `<tr><td>${fmt(p.date || sale.created_at)}</td><td>${esc(p.method || "Payment")}</td><td class="r">${money(p.amount)}</td></tr>`).join("")
    : `<tr><td colspan="3" style="color:#888">No payments recorded.</td></tr>`;

  const meta = [
    ["Invoice Number", sale.sale_number],
    ["Date", fmt(sale.created_at)],
    ["Sales Person", sale.employee || sale.salesperson || ""],
    ["Delivery Date", sale.delivery_date ? fmt(sale.delivery_date) : ""],
    ["Delivery Method", sale.delivery_method || ""],
    ["Spa JNumber", sale.jnumber || ""],
  ].filter(([, v]) => v).map(([k, v]) => `<tr><td class="mk">${k}</td><td class="mv">${esc(v)}</td></tr>`).join("");

  w.document.write(`<html><head><title>TAX INVOICE ${esc(sale.sale_number || "")}</title><style>
    *{box-sizing:border-box} body{font-family:Arial,Helvetica,sans-serif;color:#1a2b3c;padding:34px;max-width:840px;margin:0 auto;font-size:13px}
    .top{display:flex;justify-content:space-between;align-items:flex-start;border-bottom:3px solid #123a63;padding-bottom:12px}
    .brand{font-size:22px;font-weight:800;color:#123a63}
    .title{font-size:28px;font-weight:800;color:#123a63;text-align:right;letter-spacing:0.04em}
    .gst{font-size:10px;color:#666;text-align:right;margin-top:2px}
    .parties{display:flex;justify-content:space-between;gap:30px;margin:18px 0}
    .parties .lbl{font-size:11px;font-weight:800;color:#123a63;text-transform:uppercase;letter-spacing:0.05em;margin-bottom:3px}
    table.meta{border-collapse:collapse;font-size:12px}
    table.meta td{padding:2px 6px} .mk{color:#666} .mv{font-weight:700;text-align:right}
    table.lines{width:100%;border-collapse:collapse;margin-top:8px}
    table.lines th,table.lines td{border-bottom:1px solid #e6e6e6;padding:7px 8px;text-align:left}
    table.lines th{background:#123a63;color:#fff;font-size:11px;letter-spacing:0.04em}
    .c{text-align:center!important}.r{text-align:right!important}
    .col{font-size:11px;color:#666;margin-top:2px} .col img{height:18px;width:18px;object-fit:cover;vertical-align:middle;border-radius:3px;border:1px solid #ccc;margin-left:4px}
    .totwrap{display:flex;justify-content:flex-end;margin-top:12px}
    table.tot{border-collapse:collapse;min-width:300px;font-size:13px}
    table.tot td{padding:4px 10px} table.tot .k{color:#555;text-align:right} table.tot .v{text-align:right;font-weight:700;min-width:110px}
    table.tot .bal td{border-top:2px solid #123a63;font-size:16px;font-weight:800;color:#123a63;padding-top:7px}
    .pay{margin-top:16px;display:flex;gap:26px}
    .pay .sec{flex:1}
    .sech{font-size:11px;font-weight:800;color:#123a63;text-transform:uppercase;letter-spacing:0.05em;border-bottom:1px solid #cbd6e2;padding-bottom:3px;margin-bottom:6px}
    table.psum{width:100%;border-collapse:collapse;font-size:12px} table.psum td{padding:3px 6px;border-bottom:1px solid #eee}
    .opts span{display:inline-block;border:1px solid #123a63;border-radius:3px;padding:2px 9px;margin:0 5px 5px 0;font-size:11px;font-weight:700;color:#123a63}
    .noteline{font-size:11px;color:#666;margin-top:4px}
    .refund{margin-top:20px;border:1px solid #d8b4b4;background:#fdf3f3;border-radius:4px;padding:10px 12px}
    .refh{font-size:12px;font-weight:800;color:#b1281f;letter-spacing:0.05em}
    .reft{font-size:11px;color:#444;margin-top:4px;line-height:1.5}
    .sign{margin-top:26px;font-size:12px;color:#333}
    @media print{body{padding:14px}}
  </style></head><body>
    <div class="top">
      <div>${brandHead(brand)}</div>
      <div><div class="title">TAX INVOICE</div><div class="gst">NB: All of the amounts on this invoice include GST</div></div>
    </div>
    <div class="parties">
      <div style="max-width:360px">
        <div class="lbl">Invoice To:</div><b>${esc(invoiceTo)}</b><br/>
        ${isTP ? `${billerCompany ? billerCompany + "<br/>" : ""}${billerAddr}` : `${esc(client.company || "")}${client.company ? "<br/>" : ""}${addr}`}
        ${isTP ? `<div style="margin-top:10px"><div class="lbl">Job:</div><b>${esc(client.display_name || client.name || "")}</b><br/>${addr}</div>` : ""}
        ${regLines ? `<div style="margin-top:9px;font-size:12px;line-height:1.5">${regLines}</div>` : ""}
      </div>
      <div><table class="meta">${meta}</table></div>
    </div>
    <table class="lines"><thead><tr><th>Item</th><th class="c">Qty</th><th class="r">Gross</th><th class="r">Discount</th><th class="r">Nett</th></tr></thead>
      <tbody>${lineRows || '<tr><td colspan="5" style="color:#888;padding:12px">No line items on this invoice.</td></tr>'}</tbody></table>
    <div class="totwrap"><table class="tot">
      <tr><td class="k">Gross:</td><td class="v">${money(gross)}</td></tr>
      <tr><td class="k">Discount:</td><td class="v">${money(disc)}</td></tr>
      <tr><td class="k">Sale Amount:</td><td class="v">${money(saleAmt)}</td></tr>
      <tr><td class="k">Payments:</td><td class="v">${money(paid)}</td></tr>
      <tr class="bal"><td class="k">Balance Due:</td><td class="v">${money(balance)}</td></tr>
    </table></div>
    <div class="pay">
      <div class="sec"><div class="sech">Payment Summary</div><table class="psum">${payRows}</table></div>
      <div class="sec"><div class="sech">Payment Options</div>
        <div class="opts"><span>Direct Deposit</span><span>Visa</span><span>Mastercard</span><span>Amex</span><span>Eftpos</span></div>
        <div class="noteline">${bankBlock(brand) || "(Please notify us of your direct deposit)"}</div>
      </div>
    </div>
    <div class="refund">
      <div class="refh">NO REFUND POLICY</div>
      <div class="reft">We do not refund portions of deposits or full payments on &ldquo;Change Of Mind&rdquo; Cancellations. If item/s purchased has/have been delivered or picked up, returns and refunds will be at the discretion of Management.</div>
    </div>
    ${sale.note ? `<div class="noteline" style="margin-top:14px"><b>Notes:</b> ${esc(sale.note)}</div>` : ""}
    <div class="sign">Purchaser's Signature: &nbsp;. .......................................................</div>
    ${FOOTER}
  </body></html>`);
  w.document.close(); w.focus(); w.print();
}

export function printStatement(client, sales, brand) {
  const w = window.open("", "_blank");
  if (!w) { alert("Popup blocked — please allow popups to print."); return; }
  const rows = (sales || []).map((s) => {
    const paid = (s.payments || []).reduce((a, p) => a + (p.amount || 0), 0);
    const bal = Math.max((s.total || 0) - paid, 0);
    return `<tr><td>${s.sale_number}</td><td>${fmt(s.created_at)}</td><td class="r">${money(s.total)}</td><td class="r">${money(paid)}</td><td class="r"><b>${money(bal)}</b></td></tr>`;
  }).join("");
  const grand = (sales || []).reduce((a, s) => a + Math.max((s.total || 0) - (s.payments || []).reduce((x, p) => x + (p.amount || 0), 0), 0), 0);
  const now = Date.now();
  const age = { cur: 0, d30: 0, d60: 0, d90: 0, over: 0 };
  (sales || []).forEach((s) => {
    const paid = (s.payments || []).reduce((x, p) => x + (p.amount || 0), 0);
    const bal = Math.max((s.total || 0) - paid, 0);
    if (bal <= 0) return;
    const days = Math.floor((now - new Date(s.created_at).getTime()) / 86400000);
    if (days <= 30) age.cur += bal; else if (days <= 60) age.d30 += bal;
    else if (days <= 90) age.d60 += bal; else if (days <= 120) age.d90 += bal; else age.over += bal;
  });
  w.document.write(`<html><head><title>Statement — ${esc(client.name)}</title><style>
    body{font-family:Arial;color:#1a2b3c;padding:36px;max-width:820px;margin:0 auto}
    .top{display:flex;justify-content:space-between;border-bottom:3px solid #123a63;padding-bottom:12px}
    .brand{font-size:22px;font-weight:800;color:#123a63}.title{font-size:26px;font-weight:800;color:#123a63}
    table{width:100%;border-collapse:collapse;margin-top:18px;font-size:13px}
    th,td{border-bottom:1px solid #e2e2e2;padding:7px 8px;text-align:left}th{background:#eef3f9;color:#123a63}.r{text-align:right}
    table.aging{margin-top:16px} table.aging th,table.aging td{text-align:right;border:1px solid #cbd6e2} table.aging th{background:#123a63;color:#fff}
    .grand{margin-top:14px;text-align:right;font-size:18px;font-weight:800;color:#123a63}
    .bank{margin-top:14px;font-size:11px;color:#555}
  </style></head><body>
    <div class="top"><div>${brandHead(brand)}</div><div class="title">STATEMENT</div></div>
    <p><b>${esc(client.name)}</b><br/>${esc([client.address?.street, client.address?.suburb].filter(Boolean).join(", "))}<br/>Date: ${fmt()}</p>
    <table><thead><tr><th>Invoice</th><th>Date</th><th class="r">Total</th><th class="r">Paid</th><th class="r">Balance</th></tr></thead><tbody>${rows || '<tr><td colspan="5">No invoices.</td></tr>'}</tbody></table>
    <table class="aging"><thead><tr><th>Current</th><th>30 Days</th><th>60 Days</th><th>90 Days</th><th>Over 90 Days</th></tr></thead>
      <tbody><tr><td>${money(age.cur)}</td><td>${money(age.d30)}</td><td>${money(age.d60)}</td><td>${money(age.d90)}</td><td>${money(age.over)}</td></tr></tbody></table>
    <div class="grand">Total Outstanding: ${money(grand)}</div>
    ${bankBlock(brand) ? `<div class="bank">${bankBlock(brand)}</div>` : ""}
    ${FOOTER}
  </body></html>`);
  w.document.close(); w.focus(); w.print();
}

// ---- Delivery docket (Access "DELIVERY" report — no prices, acknowledgement + signature) ----
export function printDelivery(sale, client, brand) {
  const w = window.open("", "_blank");
  if (!w) { alert("Popup blocked — please allow popups to print."); return; }
  const rows = (sale.items || []).map((i) => `<tr><td class="c">${i.qty}</td><td>${esc(i.name)}${i.colour_name ? ` — <span style="color:#555">${esc(i.colour_name)}</span>` : ""}</td></tr>`).join("");
  const a = client.address || {};
  w.document.write(`<html><head><title>Delivery Docket ${sale.sale_number}</title><style>
    *{box-sizing:border-box} body{font-family:Arial;color:#1a2b3c;padding:34px;max-width:820px;margin:0 auto;font-size:13px}
    .top{display:flex;justify-content:space-between;align-items:flex-start;border-bottom:3px solid #123a63;padding-bottom:12px}
    .brand{font-size:22px;font-weight:800;color:#123a63}.title{font-size:28px;font-weight:900;color:#123a63;text-align:right;letter-spacing:0.06em}
    .dbrow{display:flex;gap:22px;margin:14px 0}
    .dbrow .cell{flex:1;border:1px solid #bbb;border-radius:4px;overflow:hidden}
    .dbh{background:#123a63;color:#fff;font-size:11px;font-weight:800;padding:4px 8px;letter-spacing:0.05em}
    .dbb{padding:8px;min-height:26px}
    .addr{margin-top:8px;font-size:14px}
    table{width:100%;border-collapse:collapse;margin-top:14px;font-size:14px}
    th,td{border-bottom:1px solid #ddd;padding:8px;text-align:left}th{background:#eef3f9;color:#123a63}.c{text-align:center;width:70px}
    .inst{margin-top:12px;padding:10px;border:1px dashed #999;font-size:13px}
    .ack{margin-top:20px;font-size:12px;color:#333;line-height:1.6;border-top:1px solid #ccc;padding-top:10px}
    .sign{margin-top:26px;font-size:13px}
  </style></head><body>
    <div class="top"><div>${brandHead(brand)}</div><div class="title">DELIVERY</div></div>
    <div class="addr"><b>Deliver to: ${esc(client.name)}</b><br/>${esc(a.street || "")}<br/>${esc([a.suburb, a.state, a.postcode].filter(Boolean).join(" "))}<br/>Invoice #${esc(String(sale.sale_number || ""))} · Date: ${fmt(sale.delivery_date || sale.created_at)}</div>
    <div class="dbrow">
      <div class="cell"><div class="dbh">DELIVERY BY:</div><div class="dbb">${esc(sale.delivery_method || "")}</div></div>
      <div class="cell"><div class="dbh">REQUEST</div><div class="dbb">${esc(sale.delivery_instructions || "")}</div></div>
    </div>
    <table><thead><tr><th class="c">Qty</th><th>Item</th></tr></thead><tbody>${rows || '<tr><td colspan="2">No items.</td></tr>'}</tbody></table>
    <div class="ack">The purchaser hereby acknowledges that the items hereon have been delivered in new condition and in good order.</div>
    <div class="sign">Purchaser's Signature: &nbsp;. .......................................................  &nbsp; Date: ____________</div>
    ${FOOTER}
  </body></html>`);
  w.document.close(); w.focus(); w.print();
}

// ---- Notes audit log ----
export function printNotes(client, notes) {
  const w = window.open("", "_blank");
  if (!w) { alert("Popup blocked — please allow popups to print."); return; }
  const rows = (notes || []).map((n) => `<tr><td>${fmt(n.created_at)}</td><td>${esc(n.employee || "")}</td><td>${esc(n.text)}</td></tr>`).join("");
  w.document.write(`<html><head><title>Notes — ${esc(client.name)}</title><style>
    body{font-family:Arial;color:#1a2b3c;padding:32px}h1{font-size:20px;color:#123a63}
    table{width:100%;border-collapse:collapse;margin-top:12px;font-size:13px}th,td{border-bottom:1px solid #e2e2e2;padding:6px 8px;text-align:left}th{background:#eef3f9;color:#123a63}
  </style></head><body><h1>Client Notes — ${esc(client.name)}</h1>
  <table><thead><tr><th>Date</th><th>By</th><th>Note</th></tr></thead><tbody>${rows || '<tr><td colspan="3">No notes.</td></tr>'}</tbody></table>
  ${FOOTER}
  </body></html>`);
  w.document.close(); w.focus(); w.print();
}
